// @ts-ignore

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  serverTimestamp,
  arrayUnion,
  getDocs,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
 deleteObject
} from "firebase/storage";

import type { AppDispatch, RootState } from "./store";
import ngeohash from "ngeohash";
import { GeoPoint } from "firebase/firestore";
import "firebase/compat/firestore";
import { GeoFirestore } from "geofirestore";
import { firebase } from "../firebase"; // ⬅️ make sure this path points to your firebaseConfig file


// ---------- Firebase refs ----------
const auth = getAuth();
const db = getFirestore();
const storage = getStorage();

// ---------- Types ----------
export type ShortstayListing = {
  listingId: string;

rateType?: "perNight" | "perHour" | "perHourPerPerson" | "perNightPerPerson" | "perWeek" | "perMonth" | "perYear";
  hostId: string;
  name?: string;
  category?: number | null;
  joinDate: string;
  isPublished: boolean;
  isFlagged: boolean;
  isComplete: boolean;
  isReviewed: boolean;
  inReview: boolean;
 isDraft: boolean; 
   isClaimed?: boolean;
   photos?: string[];
  videoUrl?: string;
  logoUrl?: string;
  createdAt?: number | null;
  updatedAt?: number | null;
  [key: string]: any;
address?: {
  country?: string;
  street?: string;
  farmName?: string;
  neighborhood?: string;
  apt?: string;
  zip?: string;
  city?: string;
  county?: string;
  latitude?: number;
  longitude?: number;
};

};

export type ShortstaysState = {
   scheduledTrips: any[];
  listings: ShortstayListing[];
  currentListing: ShortstayListing | null;
  blockedDurations: string[];
locations: {
  country?: string;
  street?: string;
  farmName?: string;
  neighborhood?: string;
  apt?: string;
  zip?: string;
  city?: string;
  county?: string;
  latitude?: number | null;
  longitude?: number | null;
}[];
  listingDiscounts: Record<string, Record<string, boolean>>;

address: {
  street?: string;
  city?: string;
  province?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
}[];


  filters: Record<string, any>; 
 hourAvailability: {
  listingId?: string;
  date?: string;
  disabledHours: number[];
  isFullyBlocked: boolean;
  isPartiallyBlocked: boolean;
} | null;

  unsubscribe?: () => void;
  loadingBlocked: boolean;
  errorBlocked: string | null;
  loading: boolean;
  error: string | null;
};

// ---------- Initial State ----------
const initialState: ShortstaysState = {
  scheduledTrips: [],
  listings: [],
  currentListing: null,
  blockedDurations: [],
  unsubscribe: undefined,
  loadingBlocked: false,
  errorBlocked: null,
  loading: false,
  error: null,
  locations: [],
  filters: {},
  address: [],
  listingDiscounts: {},
  hourAvailability: null,
};


{/*}
export const upsertShortstay = createAsyncThunk<
  ShortstayListing,
  { listingId?: string; data: Partial<ShortstayListing> }
>("shortstays/upsertShortstay", async ({ listingId, data }) => {
  const user = auth.currentUser;
  if (!user) throw new Error("User not authenticated");

  const firestoreRef = firebase.firestore();
  const geoFirestore = new GeoFirestore(firestoreRef as any);
  const geoCollection = geoFirestore.collection("shortstays");

  // ⭐ AUTO-DETECT CORRECT brandId FOR SHORTSTAYS
  // Shortstay = categoryId = 2, subcategoryId = 202
  const partnersQuery = query(
    collection(firestoreRef, "commercePartners"),
where("userId", "==", user.uid),
    where("categoryId", "==", 2),
    where("subcategoryId", "==", 202)
  );

  const partnersSnap = await getDocs(partnersQuery);

  if (partnersSnap.empty) {
    throw new Error("You must complete Shortstay commerce onboarding first.");
  }

  const partnerDoc = partnersSnap.docs[0];
  const brandId = partnerDoc.id; // 🔥 correct brandId

  // ⭐ Prepare location
  const lat = Number(data.address?.latitude);
  const lng = Number(data.address?.longitude);
  const hasCoords = !isNaN(lat) && !isNaN(lng);

  const geoPoint = hasCoords ? new firebase.firestore.GeoPoint(lat, lng) : undefined;
  const geohash = hasCoords ? ngeohash.encode(lat, lng) : undefined;

  const joinDate = new Date().toISOString();

  // ⭐ Base data (brandId forced)
  const baseData: any = {
    ...data,
    brandId,                    // 🔥 REQUIRED and auto-selected
    categoryId: 2,              // force Shortstay category
    subcategoryId: 202,         // force Shortstay subcategory
    hostId: user.uid,
    joinDate,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    ...(hasCoords && { l: geoPoint, g: geohash }),
  };
  if (listingId) {
    const docRef = firestoreRef.collection("shortstays").doc(listingId);

    if (hasCoords) {
      await geoCollection.doc(listingId).set(baseData, { merge: true });
    } else {
      await docRef.update(baseData);
    }

    const snap = await docRef.get();
    return { listingId, ...snap.data() } as ShortstayListing;
  }

 
  const createBase = {
    ...baseData,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    isPublished: false,
    isFlagged: false,
    isComplete: false,
    isReviewed: false,
    inReview: false,
    isDraft: true,
  };

  let newDocRef;
  if (hasCoords) {
    newDocRef = await geoCollection.add(createBase);
  } else {
    newDocRef = await firestoreRef.collection("shortstays").add(createBase);
  }

  await newDocRef.update({ listingId: newDocRef.id });

  const snap = await newDocRef.get();
  return { listingId: newDocRef.id, ...snap.data() } as ShortstayListing;
});
 */}



  



  export const upsertShortstay = createAsyncThunk<
  ShortstayListing,
  { listingId?: string; data: Partial<ShortstayListing> }
>("shortstays/upsertShortstay", async ({ listingId, data }) => {
  const user = auth.currentUser;
  if (!user) throw new Error("User not authenticated");

  const firestoreRef = firebase.firestore();
  const geoFirestore = new GeoFirestore(firestoreRef as any);
  const geoCollection = geoFirestore.collection("shortstays");

  // ⭐ TRY to find brandId — but don't block if not found
  const partnersQuery = query(
    collection(firestoreRef, "commercePartners"),
    where("userId", "==", user.uid),
    where("categoryId", "==", 2),
    where("subcategoryId", "==", 202)
  );

  const partnersSnap = await getDocs(partnersQuery);

  // ✅ brandId is optional — null if not a commerce partner
  const brandId = !partnersSnap.empty ? partnersSnap.docs[0].id : null;

  // ⭐ Prepare location
  const lat = Number(data.address?.latitude);
  const lng = Number(data.address?.longitude);
  const hasCoords = !isNaN(lat) && !isNaN(lng);

  const geoPoint = hasCoords ? new firebase.firestore.GeoPoint(lat, lng) : undefined;
  const geohash = hasCoords ? ngeohash.encode(lat, lng) : undefined;

  const joinDate = new Date().toISOString();

  // ⭐ Base data — brandId only included if exists
  const baseData: any = {
    ...data,
    ...(brandId && { brandId }), // ✅ only attach if commerce partner
    categoryId: 2,
    subcategoryId: 202,
    hostId: user.uid,
    joinDate,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    ...(hasCoords && { l: geoPoint, g: geohash }),
  };

  // ================================
  //        UPDATE EXISTING
  // ================================
  if (listingId) {
    const docRef = firestoreRef.collection("shortstays").doc(listingId);

    if (hasCoords) {
      await geoCollection.doc(listingId).set(baseData, { merge: true });
    } else {
      await docRef.update(baseData);
    }

    const snap = await docRef.get();
    return { listingId, ...snap.data() } as ShortstayListing;
  }

  // ================================
  //        CREATE NEW LISTING
  // ================================
  const createBase = {
    ...baseData,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    isPublished: false,
    isFlagged: false,
    isComplete: false,
    isReviewed: false,
    inReview: false,
    isDraft: true,
    isClaimed: false, 
  };

  let newDocRef;
  if (hasCoords) {
    newDocRef = await geoCollection.add(createBase);
  } else {
    newDocRef = await firestoreRef.collection("shortstays").add(createBase);
  }

  await newDocRef.update({ listingId: newDocRef.id });

  const snap = await newDocRef.get();
  return { listingId: newDocRef.id, ...snap.data() } as ShortstayListing;
});
  
 




export const upsertShortMedia = createAsyncThunk<
  { listingId: string; downloadURLs: string[] },
  { files: File[]; listingId?: string; type: "photo" | "video" },
  { rejectValue: string }
>(
  "shortstays/upsertShortMedia",
  async ({ files, listingId, type }, { rejectWithValue }) => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("Not logged in");

      const hostId = currentUser.uid;
      const joinDate = new Date().toISOString();
      let id = listingId;

      const uploaded: string[] = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const name = file.name || `${type}-${Date.now()}-${i}`;
        const path = `shortstays/${id || "new"}/${type === "photo" ? "photos" : "video"}/${name}`;
        const storageRef = ref(storage, path);

        // Upload to Firebase Storage
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        uploaded.push(url);
      }

      // ✅ If listing doesn’t exist yet → create it
      if (!id) {
        const docRef = await addDoc(collection(db, "shortstays"), {
          hostId,
          joinDate,
          photos: type === "photo" ? uploaded : [],
          videoUrl: type === "video" ? uploaded[0] : "",
          isPublished: false,
          isFlagged: false,
          isComplete: false,
          isReviewed: false,
          inReview: true,
          isDraft: true,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });

        id = docRef.id;
        await updateDoc(doc(db, "shortstays", id), { listingId: id });
      } else {
        // ✅ If listing exists → update Firestore record
        const updateData =
          type === "photo"
            ? { photos: arrayUnion(...uploaded) }
            : { videoUrl: uploaded[0] };

        await updateDoc(doc(db, "shortstays", id), {
          ...updateData,
          updatedAt: serverTimestamp(),
        });
      }

      return { listingId: id, downloadURLs: uploaded };
    } catch (err: any) {
      console.error("🔥 upsertShortMedia error:", err);
      return rejectWithValue(err.message || "Media upload failed");
    }
  }
);


// ---------- Uploads ----------
export type WebFile = File;


export const upsertShortstayVideo = createAsyncThunk<
  string, // returns video URL
  { listingId: string; video: File | Blob }, // payload
  { state: RootState; rejectValue: string }
>(
  "shortstays/upsertShortstayVideo",
  async ({ listingId, video }, { dispatch, getState, rejectWithValue }) => {
    try {
      const name =
        (video as any).name || `video-${Date.now()}.${"mp4"}`; // fallback mp4
      const path = `shortstays/${listingId}/video/${name}`;
      const storageRef = ref(storage, path);

      // upload video file
      await uploadBytes(storageRef, video);
      const url = await getDownloadURL(storageRef);

      // update Firestore listing
      await dispatch(
        upsertShortstay({
          listingId,
          data: { videoUrl: url },
        })
      );

      return url;
    } catch (e: any) {
      return rejectWithValue(e.message || "Video upload failed");
    }
  }
);


export const upsertShortstayPhoto = createAsyncThunk<
  string[],
  { listingId: string; photos: WebFile[] },
  { state: RootState; rejectValue: string }
>("shortstays/upsertShortstayPhoto", async ({ listingId, photos }, { dispatch, getState, rejectWithValue }) => {
  try {
    const uploadedUrls: string[] = [];

    for (let i = 0; i < photos.length; i++) {
      const f = photos[i];
      const name = f.name || `photo-${Date.now()}-${i}`;
      const path = `shortstays/${listingId}/photos/${name}`;
      const storageRef = ref(storage, path);

      await uploadBytes(storageRef, f);
      const url = await getDownloadURL(storageRef);
      uploadedUrls.push(url);
    }

    const existing = getState().shortstays.currentListing?.photos ?? [];
    const updated = [...existing, ...uploadedUrls];

    await dispatch(upsertShortstay({ listingId, data: { photos: updated } }));
    return updated;
  } catch (e: any) {
    return rejectWithValue(e.message || "Photo upload failed");
  }
});


// 🔥 Universal Delete Media Thunk (handles both photo & video)
export const deleteMedia = createAsyncThunk<
  { deletedPhoto?: string; deletedVideo?: boolean },
  { listingId: string; photoUrl?: string },
  { state: RootState; rejectValue: string }
>("shortstays/deleteMedia", async ({ listingId, photoUrl }, { getState, dispatch, rejectWithValue }) => {
  try {
    const state = getState().shortstays;
    const currentListing = state.currentListing;
    if (!currentListing) throw new Error("Listing not found");

    const updates: Partial<ShortstayListing> = {};
    let deletedPhoto: string | undefined;
    let deletedVideo = false;

    // 🗑️ Delete the photo if provided
    if (photoUrl) {
      try {
        const photoRef = ref(storage, photoUrl);
        await deleteObject(photoRef);
        const newPhotos = (currentListing.photos || []).filter((p) => p !== photoUrl);
        updates.photos = newPhotos;
        deletedPhoto = photoUrl;
      } catch (err) {
        console.warn("⚠️ Failed to delete photo from storage:", err);
      }
    }
// 🎬 Delete video if one exists for this listing
if (currentListing.videoUrl) {
  try {
    const videoRef = ref(storage, currentListing.videoUrl);
    await deleteObject(videoRef);

    // ✅ assign undefined instead of null for TS safety
    updates.videoUrl = undefined; 
    deletedVideo = true;
  } catch (err) {
    console.warn("⚠️ Failed to delete video from storage:", err);
  }
}


    // 🧾 Update Firestore listing if anything changed
    if (Object.keys(updates).length > 0) {
      await dispatch(upsertShortstay({ listingId, data: updates }));
    }

    return { deletedPhoto, deletedVideo };
  } catch (e: any) {
    console.error("🔥 deleteMedia error:", e);
    return rejectWithValue(e.message || "Failed to delete media");
  }
});



// ---------- Delete ----------
export const deleteShortstay = createAsyncThunk<string, string>(
  "shortstays/deleteShortstay",
  async (listingId) => {
    const docRef = doc(db, "shortstays", listingId);
    await deleteDoc(docRef);
    return listingId;
  }
);


// ---------- Listen to Multiple Published Shortstays by IDs (Realtime) ----------
export const listenToPublishedShortstays =
  () => (dispatch: AppDispatch) => {
    const q = query(
      collection(db, "shortstays"),
      where("isPublished", "==", true)
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {

        const listings: ShortstayListing[] = snap.docs.map((docSnap) => {
          const raw = docSnap.data() || {};
          return {
            listingId: docSnap.id,
            hostId: raw.hostId ?? "",
            joinDate: raw.joinDate ?? new Date().toISOString(),
            name: raw.name ?? "",
            category: raw.category ?? null,
 isPublished: true,
             isFlagged: raw.isFlagged ?? false,
            isComplete: raw.isComplete ?? false,
            isReviewed: raw.isReviewed ?? false,
            inReview: raw.inReview ?? false,
            isDraft: raw.isDraft ?? true,
            photos: raw.photos ?? [],
              address: raw.address ?? {},
            videoUrl: raw.videoUrl ?? undefined,
            logoUrl: raw.logoUrl ?? undefined,
            ...raw, // 👈 keep this to capture extra fields
            createdAt: raw.createdAt?.toMillis?.() || null,
            updatedAt: raw.updatedAt?.toMillis?.() || null,
          } as ShortstayListing;
        });


        dispatch(shortstaysSlice.actions.setListings(listings));
      },
      (error) => {
        console.error("❌ Firestore error:", error);
        dispatch(shortstaysSlice.actions.setError(error.message));
      }
    );

    dispatch(shortstaysSlice.actions.setUnsubscribe(unsubscribe));
    return unsubscribe;
  };

  // ---------- LISTENER: All Published Shortstays by a Specific Host ----------
export const listenToShortstaysByHost =
  (hostId: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if (!hostId) {
        console.warn("⚠️ listenToShortstaysByHost skipped — no hostId provided");
        return;
      }

      // 🧹 Cleanup old listeners
      const existingUnsub = getState().shortstays.unsubscribe;
      if (existingUnsub) {
        existingUnsub();
      }

      const dbRef = getFirestore();

      // 🔥 FINAL CORRECT QUERY (new structure)
      const q = query(
        collection(dbRef, "shortstays"),
        where("hostId", "==", hostId),
        where("isPublished", "==", true),
        where("categoryId", "==", 2),
        where("subcategoryId", "==", 202)
      );
      const unsubscribe = onSnapshot(
        q,
        (snap) => {
          const listings = snap.docs.map((docSnap) => {
            const data = docSnap.data() || {};
            return {
              listingId: docSnap.id,
              ...data,
              createdAt:
                data.createdAt?.toMillis?.() ??
                (typeof data.createdAt === "number" ? data.createdAt : null),
              updatedAt:
                data.updatedAt?.toMillis?.() ??
                (typeof data.updatedAt === "number" ? data.updatedAt : null),
            } as ShortstayListing;
          });

          dispatch(setListings(listings));
        },
        (err) => {
          console.error("❌ listenToShortstaysByHost error:", err.message);
          dispatch(setError(err.message));
        }
      );

      dispatch(setUnsubscribe(unsubscribe));
      return unsubscribe;
    } catch (err: any) {
      console.error("🔥 listenToShortstaysByHost FAILED:", err.message);
      dispatch(setError(err.message));
    }
  };


  export const listenToNearbyShortstays =
  (lat: number, lng: number, radiusKm: number = 2) =>
  (dispatch: AppDispatch) => {
    try {
      // ⚡️ FIX: safely cast Firestore for GeoFirestore compatibility
      // @ts-ignore - GeoFirestore expects old Firestore type
      const geoFirestore = new GeoFirestore(getFirestore());

      const geoCollection = geoFirestore.collection("shortstays");

      const query = geoCollection.near({
        center: new GeoPoint(lat, lng),
        radius: radiusKm,
      });

      const unsubscribe = query.onSnapshot(
        (snapshot: any) => {
          const stays = snapshot.docs.map((doc: any) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // Dispatch to Redux
          dispatch(shortstaysSlice.actions.setListings(stays as any));
        },
        (error: any) => {
          console.error("🔥 listenToNearbyShortstays error:", error);
          dispatch(shortstaysSlice.actions.setError(error.message));
        }
      );

      return unsubscribe;
    } catch (err: any) {
      console.error("❌ listenToNearbyShortstays setup failed:", err.message);
    }
  };


// ---------- Listeners ----------
export const listenToShortstayData =
  (listingId: string) => (dispatch: AppDispatch) => {
    const docRef = doc(db, "shortstays", listingId);

    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const raw = docSnap.data() || {};
          dispatch(
            shortstaysSlice.actions.setCurrentListing({
              listingId: docSnap.id,
              hostId: raw.hostId ?? "",
              joinDate: raw.joinDate ?? new Date().toISOString(),
              name: raw.name ?? "",
              category: raw.category ?? null,
              isPublished: raw.isPublished ?? false,
              isFlagged: raw.isFlagged ?? false,
              isComplete: raw.isComplete ?? false,
              isReviewed: raw.isReviewed ?? false,
              inReview: raw.inReview ?? false,
              photos: raw.photos ?? [],
              videoUrl: raw.videoUrl ?? undefined,
              logoUrl: raw.logoUrl ?? undefined,
              ...raw,
              createdAt: raw.createdAt?.toMillis?.() || null,
              updatedAt: raw.updatedAt?.toMillis?.() || null,
            } as ShortstayListing)
          );
        } else {
          dispatch(shortstaysSlice.actions.setCurrentListing(null));
        }
      },
      (error) => {
        dispatch(shortstaysSlice.actions.setError(error.message));
      }
    );

    return unsubscribe;
  };





  // ---------- Listen to Listings for Current Host ----------
export const listenToHostShortstays =
  () => (dispatch: AppDispatch, getState: () => RootState) => {
    // 🧩 Guard 1: ensure authenticated user
    const user = getAuth().currentUser;
    if (!user || !user.uid) {
      console.warn("⚠️ listenToHostShortstays skipped — user not authenticated");
      dispatch(setListings([])); // clear any old listings
      return;
    }

    const hostId = user.uid;
    if (typeof hostId !== "string" || !hostId.trim()) {
      console.warn("⚠️ listenToHostShortstays skipped — invalid hostId");
      dispatch(setListings([]));
      return;
    }

    // 🧩 Guard 2: clean up previous listener if any
    const existingUnsub = getState().shortstays.unsubscribe;
    if (existingUnsub) {
      console.log("🟡 Removing previous shortstays listener");
      existingUnsub();
      dispatch(setUnsubscribe(undefined));
    }

    // 🧩 Guard 3: Firestore query strictly by this hostId
    const q = query(collection(db, "shortstays"), where("hostId", "==", hostId));

    const unsubscribeFn = onSnapshot(
      q,
      (
        snap: {
          docs: {
            id: string;
            data: () => { [key: string]: any };
          }[];
        }
      ) => {
        // ✅ Always filter locally again as a fail-safe
        const listings = snap.docs
          .map((docSnap) => {
            const raw = docSnap.data() || {};
        return {
  listingId: docSnap.id,
  ...raw,

  hostId: raw.hostId ?? "",
  joinDate: raw.joinDate ?? new Date().toISOString(),
  name: raw.name ?? "",
  category: raw.category ?? null,

  isPublished: raw.isPublished ?? false,
  isFlagged: raw.isFlagged ?? false,
  isComplete: raw.isComplete ?? false,
  isReviewed: raw.isReviewed ?? false,
  inReview: raw.inReview ?? false,
  isDraft: raw.isDraft ?? false,

  photos: raw.photos ?? [],
  address: raw.address ?? {},
  videoUrl: raw.videoUrl ?? undefined,
  logoUrl: raw.logoUrl ?? undefined,

  createdAt: raw.createdAt?.toMillis?.() || null,
  updatedAt: raw.updatedAt?.toMillis?.() || null,
};

          })
          .filter((l) => l.hostId === hostId); // extra guard

        console.log(`📡 Host ${hostId} listings received: ${listings.length}`);
        dispatch(setListings(listings));
      },
      (error: { message: string }) => {
        console.error("❌ listenToHostShortstays Firestore error:", error.message);
        dispatch(setError(error.message));
      }
    );

    // ✅ Save unsubscribe to Redux
    dispatch(setUnsubscribe(unsubscribeFn));
  };



  // ---------- Listen to Multiple Published Shortstays by IDs (Realtime) ----------
export const listenToMultiShortstays =
  (ids: string[]) => (dispatch: AppDispatch) => {
    if (!ids?.length) return;

    const unsubscribers: (() => void)[] = [];

    // Firestore `in` supports max 10 IDs → chunk into groups of 10
    for (let i = 0; i < ids.length; i += 10) {
      const group = ids.slice(i, i + 10);

      const q = query(
        collection(db, "shortstays"),
        where("listingId", "in", group),
        where("isPublished", "==", true)
      );

      const unsubscribe = onSnapshot(
        q,
        (snap) => {
          const results: ShortstayListing[] = snap.docs.map((docSnap) => {
            const raw = docSnap.data() || {};
            return {
              listingId: docSnap.id,
              hostId: raw.hostId ?? "",
              joinDate: raw.joinDate ?? new Date().toISOString(),
              name: raw.name ?? "",
              category: raw.category ?? null,
              isPublished: raw.isPublished ?? false,
              isFlagged: raw.isFlagged ?? false,
              isComplete: raw.isComplete ?? false,
              isReviewed: raw.isReviewed ?? false,
              photos: raw.photos ?? [],
              videoUrl: raw.videoUrl ?? undefined,
              logoUrl: raw.logoUrl ?? undefined,
              ...raw,
              createdAt: raw.createdAt?.toMillis?.() || null,
              updatedAt: raw.updatedAt?.toMillis?.() || null,
            } as ShortstayListing;
          });

          // ✅ merge/replace in Redux
          dispatch(shortstaysSlice.actions.setListings(results));
        },
        (error) => {
          console.error("❌ listenToMultiShortstays error:", error.message);
          dispatch(shortstaysSlice.actions.setError(error.message));
        }
      );

      unsubscribers.push(unsubscribe);
    }

    // Return cleanup function to caller
    return () => {
      unsubscribers.forEach((u) => u());
    };
  };


  
  export const listenToShortstaysInReview =
  () => (dispatch: AppDispatch) => {
    const q = query(
      collection(db, "shortstays"),
      where("inReview", "==", true)
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {

        const listings: ShortstayListing[] = snap.docs.map((docSnap) => {
          const raw = docSnap.data() || {};
          return {
            listingId: docSnap.id,
            hostId: raw.hostId ?? "",
            joinDate: raw.joinDate ?? new Date().toISOString(),
            name: raw.name ?? "",
            category: raw.category ?? null,
 isPublished: true,
             isFlagged: raw.isFlagged ?? false,
            isComplete: raw.isComplete ?? false,
            isReviewed: raw.isReviewed ?? false,
            inReview: raw.inReview ?? false,
            isDraft: raw.isDraft ?? true,
            photos: raw.photos ?? [],
              address: raw.address ?? {},
            videoUrl: raw.videoUrl ?? undefined,
            logoUrl: raw.logoUrl ?? undefined,
            ...raw, // 👈 keep this to capture extra fields
            createdAt: raw.createdAt?.toMillis?.() || null,
            updatedAt: raw.updatedAt?.toMillis?.() || null,
          } as ShortstayListing;
        });


        dispatch(shortstaysSlice.actions.setListings(listings));
      },
      (error) => {
        console.error("❌ Firestore error:", error);
        dispatch(shortstaysSlice.actions.setError(error.message));
      }
    );

    dispatch(shortstaysSlice.actions.setUnsubscribe(unsubscribe));
    return unsubscribe;
  };

  


// ---------- Listen to Available Locations (Realtime) ----------
export const listenToAvailableLocations = () => (dispatch: AppDispatch) => {
  const q = collection(db, "shortstays");

  onSnapshot(
    q,
    (snap) => {
      const seen = new Set<string>();
      const locations: {
        country?: string;
        street?: string;
        farmName?: string;
        neighborhood?: string;
        apt?: string;
        zip?: string;
        city?: string;
        county?: string;
        latitude?: number | null;
        longitude?: number | null;
      }[] = [];

      snap.forEach((docSnap) => {
        const data = docSnap.data() as any;
        const addr = data.address;

        // ✅ Pull coords from GeoPoint "l" first, fall back to address fields
        const geoPoint = data.l;
        const latitude = geoPoint?.latitude ?? (addr?.latitude ? Number(addr.latitude) : null);
        const longitude = geoPoint?.longitude ?? (addr?.longitude ? Number(addr.longitude) : null);

        if (addr) {
          const key = `${addr.city || ""}-${addr.country || ""}-${addr.street || ""}`;
          if (!seen.has(key)) {
            seen.add(key);
            locations.push({
              country: addr.country ?? "",
              street: addr.street ?? "",
              farmName: addr.farmName ?? "",
              neighborhood: addr.neighborhood ?? "",
              apt: addr.apt ?? "",
              zip: addr.zip ?? "",
              city: addr.city ?? "",
              county: addr.county ?? "",
              latitude,   // ✅ from GeoPoint "l"
              longitude,  // ✅ from GeoPoint "l"
            });
          }
        }
      });

      dispatch(shortstaysSlice.actions.setLocations(locations));
    },
    (error) => {
      console.error("❌ listenToAvailableLocations error:", error);
      dispatch(shortstaysSlice.actions.setError(error.message));
    }
  );
};





// ---------- Listen to Shortstay Availability (Realtime) ----------
export const listenToShortStaysAvailability =
  (payload: { startDate: string; endDate: string }) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { startDate, endDate } = payload;
      const state = getState().shortstays;
      const { listings } = state;

      if (!startDate || !endDate) {
        console.warn("⚠️ Missing start or end date for availability filter");
        return;
      }

      console.log("🗓️ Listening to availability for:", startDate, "→", endDate);

const q = query(
  collection(db, "shortstayReservations"),
  where("isCancelled", "==", false)
);

      const unsubscribe = onSnapshot(
        q,
        (snap) => {
          // Collect reserved date ranges by listingId
          const reservedMap: Record<
            string,
            { checkIn: string; checkOut: string }[]
          > = {};

          snap.forEach((docSnap) => {
            const data = docSnap.data() as {
              listingId?: string;
              checkIn?: string;
              checkOut?: string;
            };

            if (!data.listingId || !data.checkIn || !data.checkOut) return;

            if (!reservedMap[data.listingId]) reservedMap[data.listingId] = [];
            reservedMap[data.listingId].push({
              checkIn: data.checkIn,
              checkOut: data.checkOut,
            });
          });

          // Convert string → Date for selected range
          const start = new Date(startDate);
          const end = new Date(endDate);

          // Filter listings that do NOT overlap with reserved ranges
          const availableListings = listings.filter((listing) => {
            const reservations = reservedMap[listing.listingId] || [];

            const overlaps = reservations.some((res) => {
              const resStart = new Date(res.checkIn);
              const resEnd = new Date(res.checkOut);
              // Overlap occurs if (start < resEnd && end > resStart)
              return start < resEnd && end > resStart;
            });

            return !overlaps;
          });

          console.log(
            `✅ ${availableListings.length}/${listings.length} listings available`
          );

          dispatch(shortstaysSlice.actions.setListings(availableListings));
        },
        (error) => {
          console.error("❌ listenToShortStaysAvailability error:", error);
          dispatch(shortstaysSlice.actions.setError(error.message));
        }
      );

      // Store unsubscribe for cleanup if needed
      dispatch(shortstaysSlice.actions.setUnsubscribe(unsubscribe));
      return unsubscribe;
    } catch (err) {
      console.error("🔥 listenToShortStaysAvailability failed:", err);
    }
  };



// ─── Apply or Remove Discount Booleans ────────────────────────────────
export const upsertShortDiscount = createAsyncThunk<
  { listingId: string; updatedFlags: Record<string, boolean> },
  {
    listingId: string;
    type: "is5" | "is10" | "is25" | "is50" | "is80";
    active: boolean;
  },
  { rejectValue: string }
>(
  "shortstays/upsertShortDiscount",
  async ({ listingId, type, active }, { rejectWithValue }) => {
    try {
      const docRef = doc(db, "shortstays", listingId);

      // ✅ Default discount map (all false)
      const discounts = {
        is5: false,
        is10: false,
        is25: false,
        is50: false,
        is80: false,
      };

      // ✅ Activate only one discount at a time
      discounts[type] = active;

      // ✅ Update Firestore (nested inside "discounts" object)
      await updateDoc(docRef, {
        discounts,
        discountUpdatedAt: serverTimestamp(),
      });

      // ✅ Return only booleans for Redux update
      return { listingId, updatedFlags: discounts };
    } catch (error: any) {
      console.error("🔥 upsertShortDiscount error:", error);
      return rejectWithValue(error.message || "Failed to apply discount");
    }
  }
);


/*──────────────────────────────────────────────
  THUNK — LISTEN TO ALL LISTING DISCOUNTS
──────────────────────────────────────────────*/
export const listenToAllListingDiscounts =
  () => (dispatch: AppDispatch) => {
    const ref = collection(db, "shortstays");

    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        const discountsMap: Record<string, Record<string, boolean>> = {};

        snap.forEach((docSnap) => {
          const data = docSnap.data();
          if (data?.discounts) {
            discountsMap[docSnap.id] = data.discounts;
          }
        });

        dispatch(setListingDiscounts(discountsMap));
      },
      (error) => {
        console.error("❌ listenToAllListingDiscounts error:", error);
      }
    );

    return unsubscribe;
  };



export const upsertScheduledTrip = createAsyncThunk<
  { tripId: string; data: any },
  { tripId?: string; data: Record<string, any> },
  { rejectValue: string }
>(
  "scheduledTrips/upsertScheduledTrip",
  async ({ tripId, data }, { rejectWithValue }) => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("User not authenticated");

      // ---------- UPDATE EXISTING ----------
      if (tripId) {
        const docRef = doc(db, "scheduledTrips", tripId);

        await updateDoc(docRef, {
          ...data,
          updatedAt: serverTimestamp(),
        });

        const snap = await getDoc(docRef);

        return {
          tripId,
          data: snap.data(),
        };
      }

      // ---------- CREATE NEW ----------
      const docRef = await addDoc(collection(db, "scheduledTrips"), {
        userId: user.uid,
        ...data,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      await updateDoc(docRef, { tripId: docRef.id });

      const snap = await getDoc(docRef);

      return {
        tripId: docRef.id,
        data: snap.data(),
      };
    } catch (err: any) {
      console.error("🔥 upsertScheduledTrip error:", err);
      return rejectWithValue(err.message || "Failed to upsert scheduled trip");
    }
  }
);



export const fetchScheduledTrips = createAsyncThunk<
  { trips: any[] },
  void,
  { rejectValue: string }
>(
  "scheduledTrips/fetchScheduledTrips",
  async (_, { rejectWithValue }) => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("User not authenticated");

      const q = query(
        collection(db, "scheduledTrips"),
        where("userId", "==", user.uid),
        //where("isScheduled", "==", true)
      );

      const snap = await getDocs(q);

      const trips = snap.docs.map((docSnap) => {
        const data = docSnap.data() || {};
        return {
          tripId: docSnap.id,
          ...data,
          createdAt: data.createdAt?.toMillis?.() || null,
          updatedAt: data.updatedAt?.toMillis?.() || null,
        };
      });

      return { trips };
    } catch (err: any) {
      console.error("🔥 fetchScheduledTrips error:", err);
      return rejectWithValue(err.message || "Failed to fetch scheduled trips");
    }
  }
);



// ---------- Slice ----------
const shortstaysSlice = createSlice({
  name: "shortstays",
  initialState,
  reducers: {
    setListings: (state, action: PayloadAction<ShortstayListing[]>) => {
      state.listings = action.payload;
    },
    setCurrentListing: (state, action: PayloadAction<ShortstayListing | null>) => {
      state.currentListing = action.payload;
    },
    setBlockedDurations: (state, action: PayloadAction<string[]>) => {
      state.blockedDurations = action.payload;
    },
    setUnsubscribe: (state, action: PayloadAction<(() => void) | undefined>) => {
      state.unsubscribe = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },

setLocations: (
  state,
  action: PayloadAction<
    {
      country?: string;
      street?: string;
      farmName?: string;
      neighborhood?: string;
      apt?: string;
      zip?: string;
      city?: string;
      county?: string;
      latitude?: number | null;
      longitude?: number | null;
    }[]
  >
) => {
  state.locations = action.payload;
},


setFilters: (state, action) => {
  state.filters = {
    ...state.filters,
    ...action.payload,
  };
},
clearFilters: (state) => {
  state.filters = {};
},
setListingDiscounts: (
  state,
  action: PayloadAction<Record<string, Record<string, boolean>>>
) => {
  state.listingDiscounts = action.payload;
},
setHourAvailability: (
  state,
  action: PayloadAction<{
    listingId: string;
    date: string;
    disabledHours: number[];
    isFullyBlocked: boolean;
    isPartiallyBlocked: boolean;
  }>
) => {
  state.hourAvailability = action.payload;
},


  },
  extraReducers: (builder) => {

    builder.addCase(fetchScheduledTrips.fulfilled, (state, action) => {
  state.scheduledTrips = action.payload.trips;
});

builder.addCase(upsertScheduledTrip.fulfilled, (state, action) => {

  const idx = state.scheduledTrips.findIndex(
    (t) => t.tripId === action.payload.tripId
  );

  if (idx !== -1) {
    state.scheduledTrips[idx] = {
      tripId: action.payload.tripId,
      ...action.payload.data
    };
  } else {
    state.scheduledTrips.push({
      tripId: action.payload.tripId,
      ...action.payload.data
    });
  }

});


    builder.addCase(upsertShortstay.fulfilled, (state, action) => {
      const idx = state.listings.findIndex(
        (l) => l.listingId === action.payload.listingId
      );
      if (idx !== -1) {
        state.listings[idx] = action.payload;
        if (state.currentListing?.listingId === action.payload.listingId) {
          state.currentListing = action.payload;
        }
      } else {
        state.listings.push(action.payload);
      }
    });
    builder.addCase(deleteShortstay.fulfilled, (state, action) => {
      state.listings = state.listings.filter((l) => l.listingId !== action.payload);
      if (state.currentListing?.listingId === action.payload) {
        state.currentListing = null;
      }
    });

builder.addCase(upsertShortDiscount.fulfilled, (state, action) => {
  const { listingId, updatedFlags } = action.payload;
  const idx = state.listings.findIndex((l) => l.listingId === listingId);

  if (idx !== -1) {
    state.listings[idx] = {
      ...state.listings[idx],
      discounts: updatedFlags,
    };
  }

  if (state.currentListing?.listingId === listingId) {
    state.currentListing = {
      ...state.currentListing,
      discounts: updatedFlags,
    };
  }
});


  },
});

export const {
  setListings,
  setCurrentListing,
  setBlockedDurations,
  setUnsubscribe,
  setLocations,
  setHourAvailability,
  setListingDiscounts,
  setError
} = shortstaysSlice.actions;
export const { setFilters, clearFilters } = shortstaysSlice.actions;

export default shortstaysSlice.reducer;